export default __webpack_public_path__ + "static/media/featureimg.25e26f98.png";